<template>
  <div class="error-404">
    <h1>404</h1>
    <h2>Page not found</h2>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
  .error-404 {
    text-align: center;
    padding: 50px 0;
    h1 {
      font-size: 60px;
      color: #999;
      //font-style: oblique;
      font-weight: normal;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 26px;
      color: #aaa;
      margin: 0;
      font-weight: normal;
    }
  }
</style>
